import * as React from "react";
import Svg, { Path, SvgProps } from "react-native-svg";
import { cssInterop } from "nativewind";

cssInterop(Svg, {
  className: {
    target: "style",
    nativeStyleToProp: { width: true, height: true },
  },
});

cssInterop(Path, {
  className: {
    // @ts-ignore
    target: "style",
    nativeStyleToProp: { stroke: true },
  },
});

type ClockProps = SvgProps & {
  className?: string;
  pathClassName?: string;
};

function ClockIcon({
  className,
  pathClassName = "stroke-gray-800",
  ...props
}: ClockProps) {
  return (
    <Svg
      width={16}
      height={17}
      viewBox="0 0 16 17"
      fill="none"
      {...props}
      className={className}
    >
      <Path
        d="M10.114 10.615l-2.11-2.112V4.281"
        stroke="#1A202C"
        strokeWidth={1.5}
        strokeMiterlimit={10}
        strokeLinecap="round"
        className={pathClassName}
      />
      <Path
        d="M8 14.833A6.333 6.333 0 108 2.166a6.333 6.333 0 000 12.667z"
        stroke="#1A202C"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
        className={pathClassName}
      />
    </Svg>
  );
}

export default ClockIcon;
